<template>
  <div class="counter">
    <div v-if="hasSlot && slotLocation === 'prefix'" class="counter-label">
      <slot></slot>
    </div>
    <div v-if="totalInt >= 0" class="counter-numbers">
      {{ currentInt }}<span class="total-separator">/</span>{{ totalInt }}
    </div>
    <div v-else class="counter-numbers">
      {{ currentInt }}
    </div>
    <div v-if="hasSlot && slotLocation === 'affix'" class="counter-label">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'counter',
  props: {
    current: {
      type: Number,
      required: false,
      default: 0
    },
    total: {
      type: Number,
      required: false,
      default: -1
    },
    slotLocation: {
      type: String,
      default: 'prefix',
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    currentInt() {
      if (this.current && !Number.isNaN(this.current)) {
        return Math.round(this.current);
      } else {
        return 0;
      }
    },
    totalInt() {
      if (this.total && !Number.isNaN(this.total)) {
        return Math.round(this.total);
      } else {
        return 0;
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@less/font-sizes.less";

.counter {
  text-align: center;
}

.counter-numbers {
  font-size: @app-font-size-counter-numbers;
  line-height: 0.75;
  font-weight: 900;
}

.counter-label {
  font-size: @app-font-size-counter-label;
  line-height: @app-font-size-counter-label;
  font-weight: 300;
  margin-bottom: 15px;
}
</style>
